import {paData} from "./framework/paData";
import {paTpl} from "./framework/paTpl";
import {get} from "./framework/paDom";
import {Data} from "./Data";
import {paRoute} from "./framework/paRoute";

export const Main = {
    init() {
        window.Main = this;
    },
    selectCategory(categoryId) {
        let decadeId = Data.categoryMap[categoryId].decade;
        Main.selectDecade(decadeId);
        get('[data-id="' + categoryId + '"]').addClass('active');
        get('[data-decade-id="' + decadeId + '"]').addClass('active');
        Main.showModal(categoryId);
    },
    showModal(categoryId) {
        let appWidth = document.getElementById('pa-engine-dom-wrapper').getBoundingClientRect().width,
            appPositionFromLeft = document.getElementById('pa-engine-dom-wrapper').getBoundingClientRect().left,
            modalPositionSourceX = get('[data-id="' + categoryId + '"]')[0].getBoundingClientRect().left - appPositionFromLeft,
            allowedModalArea = appWidth - 650,
            categoryData = Data.categoryMap[categoryId];
        if (paData.data['Tabellenblatt1'][categoryData.name]) {

            Main.modalSwitch(true);

            let modalData = paData.data['Tabellenblatt1'][categoryData.name],
                data = {
                    modalTitle: modalData.Name,
                    modalContent: modalData.Description,
                    modalHeader: 'Années ' + Data.tree[categoryData.decade].name
                };
            paTpl.fillPlaceholders(data);

            get('#avatar-id').src = paRoute.base + 'img/names/' + categoryId + '.png';
            get('#chart-id').src = paRoute.base + 'img/charts/' + categoryId + '.png';
            get('#modal-wrapper').addClass('active').dataset.gender = categoryData.gender;
            let modalWidth = parseInt(get('#modal-wrapper').getBoundingClientRect().width),
                positionConditions = {
                    "desktop": {
                        "left": modalPositionSourceX - modalWidth - 30,
                        "right": modalPositionSourceX + 70
                    },
                    "tablet": {
                        "left": modalPositionSourceX - modalWidth - 30,
                        "right": modalPositionSourceX + 70
                    },
                    "other": {
                        "left": modalPositionSourceX - modalWidth - 80,
                        "right": modalPositionSourceX + 20
                    }
                };

            let positionFromLeft = 0,
                positionFromRight = 0;

            if (modalPositionSourceX < allowedModalArea) {
                if (appWidth <= 1050) {
                    positionFromRight = positionConditions['tablet'].right;
                }
                else if (appWidth => 1300) {
                    positionFromRight = positionConditions['desktop'].right;
                }
                else {
                    positionFromRight = positionConditions['other'].right;
                }
                get('#modal-wrapper').style.left = positionFromRight + 'px';
            }
            else {
                if (appWidth <= 1050) {
                    positionFromLeft = positionConditions['tablet'].left;
                }
                else if (appWidth => 1300) {
                    positionFromLeft = positionConditions['desktop'].left;
                }
                else {
                    positionFromLeft = positionConditions['other'].left;
                }
                get('#modal-wrapper').style.left = positionFromLeft + 'px';
            }
        }
    },
    hideModal() {
        get('#modal-wrapper').removeClass('active');
        get('.category').removeClass('active');
    },
    selectDecade(decadeId) {
        get('.category').removeClass('active');
        get('.menu-el').removeClass('active');
        get('#pa-decades-list').addClass('active');
        get('[data-decade-id="' + decadeId + '"]').addClass('active');
        get('#background-image-block').style.backgroundImage = 'url(img/decades/' + decadeId + '.jpg)';
        get('#background-image-block').style.backgroundSize = 'cover';
        Main.hideModal();
    },
    modalSwitch(isImage) {
        if (isImage) {
            get('.avatar').removeClass('hidden');
            get('.chart').addClass('hidden');
            get('#image-button').addClass('active');
            get('#chart-button').removeClass('active');
        } else {
            get('.avatar').addClass('hidden');
            get('.chart').removeClass('hidden');
            get('#image-button').removeClass('active');
            get('#chart-button').addClass('active');
        }
    },
    hideIntro() {
        get('#pa-decades-list').addClass('white-bg');
        get('#app-home').addClass('active');
        get('.background-transparent-block').addClass('active');
        get('#pa-engine-dom-wrapper').addClass('second-bg');
        get('.app-heading').addClass('visible');
        get('.welcome-heading').addClass('hidden');
        get('.submenu').removeClass('hidden');
        get('.intro-wrapper').addClass('hidden');
    },
    showIntro() {
        get('.welcome-heading').removeClass('hidden');
        get('.intro-wrapper').removeClass('hidden');
        get('#pa-engine-dom-wrapper').removeClass('second-bg');
        get('.app-heading').removeClass('visible');
        get('.submenu').addClass('hidden');
        get('.background-transparent-block').removeClass('active');
        get('#app-home').removeClass('active');
        get('#pa-decades-list').removeClass('white-bg');
        get('#modal-wrapper').removeClass('active');
        get('#background-image-block').style.backgroundImage = '';
        get('#pa-decades-list').removeClass('active');
        get('.category').removeClass('active');
        get('.menu-el').removeClass('active');


    }

};


// WEBPACK FOOTER //
// ./src/js/Main.js